var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464 464",
    style: {
      enableBackground: "new 0 0 464 464"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M0,0h280v408H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M440,192H304l-48,32v-32h-24c-13.255,0-24-10.745-24-24V56c0-13.255,10.745-24,24-24h208 c13.255,0,24,10.745,24,24v112C464,181.255,453.255,192,440,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071BC"
    },
    d: "M232,32h208c13.255,0,24,10.745,24,24v40l0,0H208l0,0V56C208,42.745,218.745,32,232,32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4836"
    },
    d: "M232,56h16v16h-16V56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8CF26"
    },
    d: "M264,56h16v16h-16V56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3DBF50"
    },
    d: "M296,56h16v16h-16V56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M168,464L0,408V0l168,56V464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29ABE2"
    },
    d: "M440,296H304l-48-32v32h-24c-13.255,0-24,10.745-24,24v80c0,13.255,10.745,24,24,24h208 c13.255,0,24-10.745,24-24v-80C464,306.745,453.255,296,440,296z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M240,152h192v16H240V152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M256,120h16v16h-16V120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M288,120h144v16H288V120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M258.344,365.656l-16-16c-3.123-3.124-3.123-8.188,0-11.312l16-16l11.312,11.312L259.312,344 l10.344,10.344L258.344,365.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M317.656,365.656l-11.312-11.312L316.688,344l-10.344-10.344l11.312-11.312l16,16 c3.123,3.124,3.123,8.188,0,11.312L317.656,365.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M272.406,365.441l16.009-48.001l15.178,5.062l-16.009,48.001L272.406,365.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M352,336h16v16h-16V336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M240,384h16v16h-16V384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M272,384h160v16H272V384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M384,336h16v16h-16V336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M416,336h16v16h-16V336z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F15A24"
    },
    cx: 112,
    cy: 240,
    r: 24
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.44b7113b60d1aba61f057b16001ee107.svg";
export { ForwardRef as ReactComponent };